import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import LanguageSwitcher from './LanguageSwitcher';

interface Props {
  onOpenFolder: () => void;
  onToggleSort: () => void;
  onCopy: () => void | Promise<void>;
  pickedCount: number;
  sortMode: 'name' | 'date';
  hideButtons?: boolean;
}

export default function Header({
  onOpenFolder,
  onToggleSort,
  onCopy,
  pickedCount,
  sortMode,
  hideButtons = false,
}: Props) {
  const { t, i18n } = useTranslation();
  const nf = useMemo(() => new Intl.NumberFormat(i18n.language), [i18n.language]);

  return (
    <header className="pad-4 sticky-header app-header" style={{ borderBottom: '1px solid var(--ls-border)' }}>
      <div className="flex-space header-inner">
        <h1 className="brand-title">
          <img src="/icon.png" alt="" className="logo" />
          LensSift
        </h1>
        <div className="flex-row gap-2 header-actions">
          {!hideButtons && (
            <>
              <button className="btn-primary" onClick={onOpenFolder}>{t('open-button')}</button>
              <button className="btn-primary" onClick={onToggleSort}>
                {t('sort-label')} {sortMode === 'name' ? t('sort-name') : t('sort-date')}
              </button>
              <button className="btn-primary" disabled={!pickedCount} onClick={onCopy}>
                {t('copy-button')}
                {!!pickedCount && (
                  <span
                    style={{
                      background: '#fff',
                      color: 'var(--ls-primary)',
                      borderRadius: 12,
                      padding: '0 6px',
                      marginLeft: 4,
                      fontWeight: 700,
                      fontSize: 'var(--fs-sm)',
                    }}
                  >
                    {nf.format(pickedCount)}
                  </span>
                )}
              </button>
            </>
          )}
          <LanguageSwitcher />
        </div>
      </div>
    </header>
  );
}
